import React, { memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import useColorFilter from 'root/lib/hooks/useColorFilter';

import { neutralFilter } from './filters';

const SVGFilter = memo(({ image, filter }) => {
  const svgRef = useColorFilter(filter);
  return <OptimizedSVG as={image} ref={svgRef} />;
});

SVGFilter.propTypes = {
  filter: PropTypes.string,
  image: PropTypes.object.isRequired,
};

SVGFilter.defaultProps = {
  filter: neutralFilter,
};

const OptimizedSVG = styled.img`
  transform: translateZ(0);
  perspective: 1000px;
  backface-visibility: hidden;
`;

export default SVGFilter;
